import { calmTokens as t } from '../../shared/tokens';
import { IconX } from '../../shared/icons';

/**
 * Toast « Calm » partagé.
 * feedback : { message, type: 'success'|'error'|'info', visible, actions?: [{ label, onClick, primary? }] }
 */
export default function CalmToast({ feedback, onClose }) {
  if (!feedback?.visible) return null;
  const accent =
    feedback.type === 'success'
      ? t.credit
      : feedback.type === 'error'
        ? t.debit
        : t.accent;
  const actions = Array.isArray(feedback.actions) ? feedback.actions : [];

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        // `viewport-fit=cover` + status bar translucide : sans la safe-area le
        // toast passe sous l'encoche en PWA iOS.
        top: 'calc(24px + env(safe-area-inset-top))',
        right: 'calc(24px + env(safe-area-inset-right))',
        zIndex: 80,
        maxWidth: 380,
        background: t.surface,
        border: `1px solid ${t.borderS}`,
        borderRadius: 14,
        padding: '12px 16px',
        boxShadow: '0 18px 40px rgba(0,0,0,0.45)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        color: t.text,
        fontFamily: t.fontUi,
        fontSize: 13,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: accent,
          marginTop: 5,
          flexShrink: 0,
        }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ lineHeight: 1.4 }}>{feedback.message}</div>
        {actions.length > 0 && (
          <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
            {actions.map((a) => (
              <button
                key={a.label}
                type="button"
                onClick={a.onClick}
                style={{
                  padding: '6px 12px',
                  borderRadius: 999,
                  fontSize: 12,
                  fontWeight: 500,
                  fontFamily: t.fontUi,
                  cursor: 'pointer',
                  background: a.primary ? t.text : 'transparent',
                  color: a.primary ? t.bg : t.textDim,
                  border: a.primary ? 'none' : `1px solid ${t.border}`,
                }}
              >
                {a.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fermer"
        style={{
          width: 24,
          height: 24,
          borderRadius: 7,
          background: 'transparent',
          border: 'none',
          color: t.textMute,
          cursor: 'pointer',
          display: 'grid',
          placeItems: 'center',
          padding: 0,
          flexShrink: 0,
        }}
      >
        <IconX size={12} />
      </button>
    </div>
  );
}
